<template>
  <div class="recaptcha-notice">
    Questo sito è protetto da reCAPTCHA e si applicano la
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a> e i
    <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Termini di servizio</a> di Google.
  </div>
</template>

<script>
export default {
  name: 'RecaptchaNoticeComponent'
}
</script>
